var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid container-max-width py-2",
      attrs: { id: "checkout-wrapper", "app-call": "app.common.initDatePicker" }
    },
    [
      _c("div", { staticClass: "cart-content" }, [
        _c("div", { staticClass: "cart-contents-wrapper w-100" }, [
          _c(
            "form",
            {
              attrs: {
                method: "POST",
                id: "wholesaleOrderForm",
                name: "wholesaleOrderForm",
                action: "/checkout/place"
              }
            },
            [
              _c("input", {
                attrs: { type: "hidden", name: "_token" },
                domProps: { value: _vm.csrf }
              }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("div", { staticClass: "checkout-card card" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _c("h2", [_vm._v("Pickup or Delivery")]),
                      _vm._v(" "),
                      _c("p", [_vm._v("Please choose an option below.")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-check form-check-inline mr-2" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-start align-items-center"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.includeShipping,
                                    expression: "includeShipping"
                                  }
                                ],
                                staticClass: "form-check-input m-0",
                                attrs: {
                                  type: "radio",
                                  name: "includeDelivery"
                                },
                                domProps: {
                                  value: true,
                                  checked: _vm._q(_vm.includeShipping, true)
                                },
                                on: {
                                  change: function($event) {
                                    _vm.includeShipping = true
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: "inputDelivery" }
                                },
                                [_vm._v("Delivery")]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-check form-check-inline" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-start align-items-center"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.includeShipping,
                                    expression: "includeShipping"
                                  }
                                ],
                                staticClass: "form-check-input m-0",
                                attrs: {
                                  type: "radio",
                                  name: "includeDelivery"
                                },
                                domProps: {
                                  value: false,
                                  checked: _vm._q(_vm.includeShipping, false)
                                },
                                on: {
                                  change: function($event) {
                                    _vm.includeShipping = false
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: "inputPickup" }
                                },
                                [_vm._v("Pickup")]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "checkout-card card" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _c("h2", [_vm._v("Contact Information")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "full_name" } }, [
                          _vm._v("Contact Person")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userInformation.full_name,
                              expression: "userInformation.full_name"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "full_name",
                            name: "full_name",
                            "aria-describedby": "full_name",
                            placeholder: "Full Name"
                          },
                          domProps: { value: _vm.userInformation.full_name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.userInformation,
                                "full_name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "phone" } }, [
                          _vm._v("Phone Number")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userInformation.phone,
                              expression: "userInformation.phone"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "phone",
                            name: "phone",
                            "aria-describedby": "phone",
                            placeholder: "+1() -"
                          },
                          domProps: { value: _vm.userInformation.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.userInformation,
                                "phone",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "email" } }, [
                          _vm._v("Email Address")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userInformation.email,
                              expression: "userInformation.email"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "email",
                            name: "email",
                            "aria-describedby": "email",
                            placeholder: "jsmith@gmail.com"
                          },
                          domProps: { value: _vm.userInformation.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.userInformation,
                                "email",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "checkout-card card" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _c("h2", [_vm._v("Order Notes")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userInformation.order_notes,
                              expression: "userInformation.order_notes"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "order_notes",
                            name: "order_notes",
                            "aria-describedby": "order_notes",
                            placeholder:
                              "Please add any order notes, special requests, or delivery instructions here.",
                            rows: "6"
                          },
                          domProps: { value: _vm.userInformation.order_notes },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.userInformation,
                                "order_notes",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-6" }, [
                  _c(
                    "div",
                    { staticClass: "notes-wrapper checkout-card card" },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("order-table-cart-component", {
                        attrs: { cartItems: _vm.cart, checkOutCart: true }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body p-0" }, [
                        _c("div", { staticClass: "table-wrapper mb-3" }, [
                          _c("div", { attrs: { id: "order-container" } }),
                          _vm._v(" "),
                          _c("div", { staticClass: " totals" }, [
                            _c("table", { staticClass: "table table-totals" }, [
                              _c("tbody", [
                                !_vm.isTaxExempt
                                  ? _c("tr", { staticClass: "subtotal lead" }, [
                                      _c("th", [_vm._v("Subtotal")]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currency")(_vm.cartSubtotal)
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isTaxExempt
                                  ? _c("tr", { staticClass: "tax lead" }, [
                                      _c("th", [_vm._v("Tax:")]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currency")(_vm.cartTax)
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("tr", { staticClass: "total lead" }, [
                                  _c("th", [_vm._v("Order Total:")]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(_vm.cartTotal)
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "finalize-order p-2 text-center" },
                            [
                              _c("p", { staticClass: "mb-2" }, [
                                _vm._v("Additional delivery fees may apply")
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-darker",
                                  attrs: { disabled: _vm.isDisabled },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.createOrder($event)
                                    }
                                  }
                                },
                                [_vm._v("Submit Order")]
                              ),
                              _vm._v(" "),
                              _vm._m(3)
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("input", {
                attrs: { id: "amount", name: "amount", type: "hidden" },
                domProps: { value: _vm.cartTotal }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.includeShipping,
                    expression: "includeShipping"
                  }
                ],
                attrs: {
                  type: "hidden",
                  id: "include_shipping",
                  name: "include_shipping"
                },
                domProps: { value: _vm.includeShipping },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.includeShipping = $event.target.value
                  }
                }
              })
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12" }, [
        _c(
          "div",
          {
            staticClass:
              "checkout-intro mb-2 w-100 justify-content-between align-items-center d-block d-md-flex"
          },
          [
            _c("h1", { staticClass: "d-inline-block mb-1 mb-md-0" }, [
              _vm._v("Submit Order")
            ]),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "btn btn-darker", attrs: { href: "/order" } },
              [_vm._v("Keep Shopping")]
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkout-card card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("h2", [_vm._v("Preferred Day & Time")]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group date mb-1" }, [
          _c("input", {
            staticClass: "form-control",
            attrs: {
              type: "text",
              name: "requested_date",
              id: "requested_date",
              autocomplete: "new-password"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input-group-append" }, [
            _c("span", { staticClass: "input-group-text" }, [
              _c("i", { staticClass: "fa fa-calendar" })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-check form-check-inline mr-2" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-content-start align-items-center" },
            [
              _c("input", {
                staticClass: "form-check-input m-0",
                attrs: {
                  type: "radio",
                  name: "requested_time",
                  id: "deliveryMorning",
                  value: "morning"
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "deliveryMorning" }
                },
                [_vm._v("Morning")]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-check form-check-inline" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-content-start align-items-center" },
            [
              _c("input", {
                staticClass: "form-check-input m-0",
                attrs: {
                  type: "radio",
                  name: "requested_time",
                  id: "deliveryAfternoon",
                  value: "afternoon"
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "deliveryAfternoon" }
                },
                [_vm._v("Afternoon")]
              )
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c(
        "div",
        {
          staticClass:
            "d-block d-md-flex justify-content-between align-items-center"
        },
        [
          _c("h2", { staticClass: "d-inline mb-1 mb-md-0" }, [
            _vm._v("Order Summary")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "disclaimer mt-2" }, [
      _vm._v('By clicking "Submit Order" you agree to our '),
      _c(
        "a",
        { attrs: { href: "https://plants.natorp.com/terms-and-conditions" } },
        [_vm._v("Terms & Conditions")]
      ),
      _vm._v(" and "),
      _c("a", { attrs: { href: "https://plants.natorp.com/privacy-policy" } }, [
        _vm._v("Privacy Policy")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }